import * as React from 'react';
import marksActions from '../../../redux/marks/actions';
import { MarksState, MarksActionTypes } from '../../../redux/marks/types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../../redux/reducers';
import InputCodeModal from '../InputCodeModal';

const { closeConfirmEmployeeCodeModal, confirmEmployeeCodeMarks } = marksActions;

export interface MapStateToProps {
  /** stan otwarcia modala */
  opened: MarksState['emailEmployeeCodeConfirmModal']['opened'];
  /** stan ładowania modala */
  loading: MarksState['emailEmployeeCodeConfirmModal']['loading'];
  /** stan błędu */
  error: MarksState['emailEmployeeCodeConfirmModal']['error'];
}
export interface MapDispatchToProps {
  /** akcja zamknięcia modala */
  closeConfirmEmployeeCodeModal: () => MarksActionTypes;
  /** akcja potwierdzenia wyboru nauczyciela */
  confirmEmployeeCodeMarks: (code: string) => MarksActionTypes;
}
export type Props = MapStateToProps & MapDispatchToProps;

/**
 * Komponent modala wyboru pracownika, który potwierdzi tożsamość użytkownika
 *
 */
export class InputEmployeeCodeMarksModal extends React.Component<Props> {
  render(): React.ReactElement {
    const { opened, loading, error, closeConfirmEmployeeCodeModal, confirmEmployeeCodeMarks } = this.props;
    return (
      <InputCodeModal
        opened={opened}
        loading={loading}
        error={error}
        mode={'email'}
        confirm={confirmEmployeeCodeMarks}
        close={closeConfirmEmployeeCodeModal}
        titleTranslationKey='INPUT_CODE_EMAIL_EMPLOYEE_TITLE_MODAL'
      />
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  opened: state.Marks.emailEmployeeCodeConfirmModal.opened,
  loading: state.Marks.emailEmployeeCodeConfirmModal.loading,
  error: state.Marks.emailEmployeeCodeConfirmModal.error,
});

const mapDispatchToProps: MapDispatchToProps = {
  closeConfirmEmployeeCodeModal,
  confirmEmployeeCodeMarks,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(InputEmployeeCodeMarksModal) as React.ComponentType<any>;
